import React, { useState } from 'react';

import { highlightNodes } from '../../util/d3/highlightNodes';

import { Data } from '../../types';

import ForceChart from './ForceChart';
import Legend from './Legend';

import '../../styles/Map.css';

type Props = {
  data: Data;
}

const Map = ({ data }: Props) => {

  const [ node, setNode ] = useState('');

  const updateNode = (value: string) => {
    setNode(value);
    if(data) highlightNodes(data, value);
  }; 

  return (
    <div className="be_Map">
          <Legend data={data} node={node} setNode={setNode}/>
        <div id='be_chart'>
            <ForceChart data={data} updateNode={updateNode} />
        </div>
    </div>
  );
};

export default Map;